<script setup>
// import { ref } from 'vue';
import BatchProfileTable from "./Tables/BatchProfileTable.vue";
import ArgonInput from "@/components/ArgonInput.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import ArgonRadio from "@/components/ArgonRadio.vue";
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Batch Profile</h6>
                </div>
                <div class="py-4 container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Block</label>
                            <select class="form-control" v-model="model.batch.block">
                                <option v-for="(item,index) in batchblockidList" :key="index" :value="item.batchblockid">
                                    {{ item.batchblockid }} - {{ item.blockname }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Product</label>
                            <select class="form-control" v-model="model.batch.product" @change="onChangeProduct">
                                <option value="SW">Sawit</option>
                                <option value="GT">Getah</option>
                                <option value="DR">Durian</option>
                                <option value="KK">Koko</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Clone</label>
                            <select class="form-control" v-model="model.batch.clone" >
                                <option value="1" v-if="model.batch.product === 'SW'">FGV</option>
                                <option value="2" v-if="model.batch.product === 'SW'">AAR</option>
                                <option value="3" v-if="model.batch.product === 'SW'">GH 500</option>
                                <option value="4" v-if="model.batch.product === 'SW'">KK</option>
                                <option value="5" v-if="model.batch.product === 'SW'">UP</option>
                                <option value="9" v-if="model.batch.product === 'SW'">IOI</option>
                                <option value="6" v-if="model.batch.product === 'GT'" >PB 350</option>
                                <option value="7" v-if="model.batch.product === 'DR'">Musang King</option>
                                <option value="8" v-if="model.batch.product === 'DR'">Duri Hitam</option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Type</label>
                            <div class="d-flex align-items-center">
                                <argon-radio id="Biji" name="batch-type" class="me-3" :checked="model.batch.type === 0" @click="model.batch.type = 0">Biji</argon-radio>
                                <argon-radio id="Semai" name="batch-type" :checked="model.batch.type === 1" @click="model.batch.type = 1">Pokok</argon-radio>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Quantity</label>
                            <input class="form-control" v-model="model.batch.quantity" id="input_quantity" type="text" placeholder="quantity..." />
                        </div>
                        <div class="col-md-4">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <argon-input type="text" id="input_remark" v-model="model.batch.remark"  placeholder="Remark...." />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Date Semai</label>
                            <input class="form-control" v-model="model.batch.datesemai" id="input_semai_date" type="date" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Date Alih</label>
                            <input class="form-control" v-model="model.batch.datealih" id="input_alih" type="date" />
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="addBatch" style="float: right;" id="btn_add">Add</button>
                            <button class="btn btn-warning me-3" @click="showPopupBlockModal" style="float: right;" id="btn_add_block">Add Block</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="mt-4 row">
        <div class="col-12">
            <BatchProfileTable :key="componentKey" />
        </div>
    </div>
</div>

<div class="row">
    <NurseryBlockModal @updateBatchBlockDLL="listAllBatchBlockId">
    </NurseryBlockModal>
</div>
</template>


<script>
import axios from 'axios';
import { Modal } from 'bootstrap';
import NurseryBlockModal from './components/NurseryBlockModal.vue';
export default {
  name:'batchCreate',
  components:{
    NurseryBlockModal,
  },
  data(){
    return {
        batchblockidList:[],
        componentKey: 0,
        myModal:'',
    //   errorList: '',
      model:{
        batch:{
            clone:"1",
            product:'SW',
            block:'',
            quantity:'',
            remark:'',
            datesemai: new Date().toISOString().slice(0,10),
            type: 0,
            datealih:''
        }
      },
    }
  },
  mounted(){
    this.listAllBatchBlockId();
    this.myModal = new Modal(document.getElementById('NurseryBlockModal'));
  },
  methods: {
    onChangeProduct(){
        if(this.model.batch.product === 'GT'){
            this.model.batch.clone ='6';
        }else if(this.model.batch.product === 'DR'){
            this.model.batch.clone ='7';
        }else{
            this.model.batch.clone ='1';
        }
    },
    addBatch(){
        // console.log(this.model.stockProfile);
        // var mythis = this;
        axios.post('nursery/addNurseryBatch',this.model.batch)
            .then(res => {
                alert(res.data.message);
                this.model.batch = {
                    clone:"1",
                    product:'SW',
                    block: this.batchblockidList[0].batchblockid,
                    quantity:'',
                    remark:'',
                    datesemai:new Date().toISOString().slice(0,10),
                    type:0,
                    datealih:''
                };
                this.componentKey += 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Vehicle No and type is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    listAllBatchBlockId(){
        axios.get('nursery/listAllBatchBlockId')
            .then(res => {
              this.batchblockidList = res.data.batchblockid;
              this.model.batch.block = res.data.batchblockid[0].batchblockid;
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    },
    showPopupBlockModal(){
        this.myModal.show();
    }
    
  },
}
</script>
